<div
  i18n="@@deleteAccountDialog.title"
  class="u-borderBottom-grey100"
  mat-dialog-title
>
  Delete {{ account?.first_name }}'s account
</div>
<mat-dialog-content class="u-borderBottom-grey100">
  <p
    class="u-marginBottom-16 u-text-maxWidth u-paddingTop-16"
    i18n="@@deleteAccountDialog.content"
  >
    You are about to delete {{ account?.first_name }} {{ account?.last_name }}.
    You won't be able to recover this account once deleted.
  </p>
  <mat-checkbox
    (change)="checkedChange('permaban', $event.checked)"
    class="mat-checkbox--longText"
    color="primary"
    [disableRipple]="true"
  >
    <ng-container i18n="@@deleteAccountDialog.permaban.CheckboxLabel"
      >Prevent {{ account?.email }} from signing up again.</ng-container
    >
  </mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <div class="u-padding-0-8">
    <button i18n="@@global.cancel" mat-button [mat-dialog-close]>Cancel</button>
    <button
      i18n="@@global.confirm"
      mat-button
      [mat-dialog-close]="params"
      color="primary"
    >
      Confirm
    </button>
  </div>
</mat-dialog-actions>
